import React, {useMemo} from "react"
import PropTypes from "prop-types"
import {Box, Paper, Typography} from "@mui/material"
import DataGridTable from "src/v2/components/Table/data-grid-table"
import {formatMemoryValue, getVisibleMemoryRows} from "./validation-memory"

const DATA_GRID_HEADER_HEIGHT = 64
const DATA_GRID_ROW_HEIGHT = 48
const EMPTY_MEMORY_OVERLAY_HEIGHT = 104
const EMPTY_MEMORY_TABLE_HEIGHT = DATA_GRID_HEADER_HEIGHT + EMPTY_MEMORY_OVERLAY_HEIGHT
const MAX_MEMORY_TABLE_HEIGHT = 544

const ValidationMemoryTable = ({title, columns, rows}) => {
    const dataGridColumns = useMemo(() => columns.map(({type, ...column}) => ({
        ...column,
        sortable: false,
        filterable: false,
        renderCell: (params) => formatMemoryValue(params.value, type),
    })), [columns])
    const visibleRows = useMemo(() => getVisibleMemoryRows(rows), [rows])
    const tableHeight = Math.min(
        MAX_MEMORY_TABLE_HEIGHT,
        Math.max(
            EMPTY_MEMORY_TABLE_HEIGHT,
            DATA_GRID_HEADER_HEIGHT + (visibleRows.length * DATA_GRID_ROW_HEIGHT)
        )
    )
    const headingId = `validation-memory-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`

    return (
        <Paper
            component="section"
            elevation={0}
            aria-labelledby={headingId}
            sx={{
                minWidth: 0,
                p: {xxxs: 2, md: 3},
                bgcolor: "background.paper",
                borderRadius: 0,
            }}
        >
            <Typography id={headingId} variant="h6" sx={{mb: 2, color: "common.white"}}>
                {title}
            </Typography>
            <Box
        sx={{
            height: tableHeight,
            width: "100%",
            minWidth: 0,
            overflow: "hidden",
                }}
            >
                <DataGridTable
                    aria-label={title}
                    columns={dataGridColumns}
                    rows={visibleRows}
                    showPagination={false}
                    contained
                    verticalScroll="hidden"
                    rowHeight={DATA_GRID_ROW_HEIGHT}
                    getRowId={(row) => row.id}
                    sx={{
                        minWidth: 0,
                        "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                            outline: "2px solid",
                            outlineColor: "primary.main",
                            outlineOffset: -2,
                        },
                    }}
                />
            </Box>
        </Paper>
    )
}

ValidationMemoryTable.propTypes = {
    title: PropTypes.string.isRequired,
    columns: PropTypes.arrayOf(PropTypes.shape({
        field: PropTypes.string.isRequired,
        headerName: PropTypes.string.isRequired,
        type: PropTypes.string,
        minWidth: PropTypes.number,
    })).isRequired,
    rows: PropTypes.array,
}

ValidationMemoryTable.defaultProps = {
    rows: [],
}

export default ValidationMemoryTable
